import { memo, useState } from 'react';
import { Button, useTranslation } from '@packages/utils';
import { TRegisterActionProps } from './RegisterAction.types';
import NewRegistrationModal from './NewRegistrationModal';
import { RegistrationContextProvider } from './NewRegistrationModal/context/NewRegistrationModalContext';

export const eventsItemKey = 'descriptions.event-landing.homepage.events-item';

export const RegisterAction = memo(
  ({ isAllClassesFinished, eventId, size = 'large' }: TRegisterActionProps) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    return (
      <>
        <Button
          className="w-100"
          size={size}
          onClick={() => setOpen(true)}
          type="primary"
          color="primary"
          disabled={isAllClassesFinished}
          data-cy="register-btn"
        >
          {t(`${eventsItemKey}.REGISTER_BTN`)}
        </Button>
        <RegistrationContextProvider
          open={open}
          setOpen={setOpen}
          eventId={eventId}
        >
          <NewRegistrationModal
            open={open}
            setOpen={setOpen}
            eventId={eventId}
          />
        </RegistrationContextProvider>
      </>
    );
  },
);
